var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 14.1676C6.98393 14.1676 7.91667 13.2349 7.91667 12.0843C7.91667 10.9337 6.98393 10.001 5.83333 10.001C4.68274 10.001 3.75 10.9337 3.75 12.0843C3.75 13.2349 4.68274 14.1676 5.83333 14.1676Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 14.1676C15.316 14.1676 16.2487 13.2349 16.2487 12.0843C16.2487 10.9337 15.316 10.001 14.1654 10.001C13.0148 10.001 12.082 10.9337 12.082 12.0843C12.082 13.2349 13.0148 14.1676 14.1654 14.1676Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 5.83268C11.1519 5.83268 12.0846 4.89994 12.0846 3.74935C12.0846 2.59876 11.1519 1.66602 10.0013 1.66602C8.85071 1.66602 7.91797 2.59876 7.91797 3.74935C7.91797 4.89994 8.85071 5.83268 10.0013 5.83268Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3327C9.99935 16.0315 8.13385 14.166 5.83268 14.166C3.53149 14.166 1.66602 16.0315 1.66602 18.3327",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.3327C18.3333 16.0315 16.4678 14.166 14.1667 14.166C11.8655 14.166 10 16.0315 10 18.3327",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 10.0007C14.1673 7.69948 12.3018 5.83398 10.0007 5.83398C7.69948 5.83398 5.83398 7.69948 5.83398 10.0007",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupLogo);
export default __webpack_public_path__ + "static/media/group-logo.392547820aa4ca3f190224768ecbf4e9.svg";
export { ForwardRef as ReactComponent };